<template>
    <div style="position: relative;">
        <b-navbar type="light" toggleable="sm" class="shadow-sm module-navbar">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item
                        v-if="
                            isClientDashboard &&
                            permissions['client.profile.create'] == 1
                        "
                        href="/view/client/new"
                        @click.prevent="goToNew()"
                    >
                        <i class="cus-add"></i>New Client
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            isClientProfile &&
                            !isEditMode &&
                            !isClientNoOwner &&
                            permissions['client.profile.update'] == 1
                        "
                        @click="goToEdit()"
                    >
                        <i class="cus-page-white-edit"></i>Edit Client
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            _hasAccess('client.profile.merge') &&
                            isClientProfile &&
                            !isEditMode &&
                            !isClientNoOwner &&
                            permissions['client.profile.update'] == 1
                        "
                        @click="mergeClient()"
                    >
                        <i class="cus-arrow-refresh"></i>Merge Client
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            isClientProfile &&
                            !isEditMode &&
                            currentClient.index != 1 &&
                            permissions['client.profile.delete'] == 1
                        "
                        @click="deleteClient()"
                    >
                        <i class="cus-delete"></i>Delete Client
                    </b-nav-item>

                    <b-nav-item
                        v-if="isClientProfile && isEditMode && !isSavingClient"
                        @click="triggerSave()"
                    >
                        <i class="cus-disk"></i>Save
                    </b-nav-item>
                    <b-nav-item
                        v-if="isClientProfile && isEditMode && !isSavingClient"
                        @click="cancelEdit()"
                    >
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>

                    <b-nav-item
                        v-if="isClientNew && !isSavingNewClient"
                        @click="saveNewClient()"
                    >
                        <i class="cus-disk"></i>Save + Done
                    </b-nav-item>
                    <b-nav-item
                        v-if="isClientNew && !isSavingNewClient"
                        @click="saveNewClient(true)"
                    >
                        <i class="cus-disk"></i>Save + Add New
                    </b-nav-item>
                    <b-nav-item
                        v-if="isClientNew && !isSavingNewClient"
                        @click="cancelNew"
                    >
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>

                    <b-nav-item
                        v-if="
                            (isClientNew && isSavingNewClient) ||
                            (isClientProfile && isEditMode && isSavingClient)
                        "
                        disabled
                    >
                        <i class="cus-hourglass"></i>Saving...
                    </b-nav-item>
                </b-navbar-nav>
                <!------- Letter (View) ------->
                <b-navbar-nav v-if="isLetter && profile.mode == 'VIEW'">
                    <b-nav-item
                        v-if="
                            !profile.isLock &&
                            _hasAccess('client.letter.edit')
                        "
                        @click="profile.mode = 'EDIT'"
                    >
                        <i class="cus-page-white-edit"></i>Edit Letter
                    </b-nav-item>
                    <b-nav-item-dropdown
                        v-if="
                            _hasAccess('client.letter.email') ||
                            _hasAccess('client.letter.print')
                        "
                    >
                        <template slot="button-content">
                            <i class="cus-page-attach"></i>
                            Export
                        </template>
                        <b-dropdown-item
                            v-if="_hasAccess('client.letter.email')"
                            @click="emailLetter()"
                        >
                            <i class="cus-email"></i>
                            Email Letter
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="_hasAccess('client.letter.print')"
                            @click="printLetter()"
                        >
                            <i class="cus-printer"></i>
                            Print Letter
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item
                        v-if="
                            !profile.isLetterEdit &&
                            !profile.isLock &&
                            letter.hasSignature &&
                            !letter.hasSigned
                        "
                        @click="signLetter()"
                    >
                        <i class="cus-page-white-key"></i>Sign Letter
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            !profile.isLetterEdit &&
                            !profile.isLock &&
                            letter.hasSignature &&
                            letter.hasSigned
                        "
                        @click="clearSigniture()"
                    >
                        <i class="cus-page-white-key"></i>Clear Signature
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            !profile.isLetterEdit &&
                            !profile.isLock &&
                            _hasAccess('patient.letter.lock')
                        "
                        @click="lockLetter()"
                    >
                        <i class="cus-lock"></i>Lock Letter
                    </b-nav-item>
                    <b-nav-item
                        v-if="
                            !profile.isLock &&
                            _hasAccess('client.letter.delete')
                        "
                        @click="deleteLetter()"
                    >
                        <i class="cus-delete"></i>Delete Letter
                    </b-nav-item>
                </b-navbar-nav>
                <!------- Letter (Edit) ------->
                <b-navbar-nav
                    v-if="
                        isLetter && profile.mode == 'EDIT' && profile.isSaving
                    "
                >
                    <b-nav-item>
                        Saving...
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav
                    v-if="
                        isLetter &&
                        profile.mode == 'EDIT' &&
                        profile.isSaving === false
                    "
                >
                    <b-nav-item @click="saveEditLetter">
                        <i class="cus-disk"></i>Save + Done
                    </b-nav-item>
                    <b-nav-item @click="profile.mode = 'VIEW'">
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>
                <NavbarWebform
                    v-if="isWebform"
                    :profile="profile"
                    @changeEditMode="edit => changeEditMode(edit)"
                    @changeIsSaving="isSaving => changeIsSaving(isSaving)"
                    @deleteWebform="webform => deleteWebform(webform)"
                    @sendEmail="webform => sendEmail(webform)"
                    @sendSMS="webform => sendSMS(webform)"
                />
            </b-collapse>
            <b-navbar-nav class="ml-auto">
                <b-nav-form
                    @click="$refs['select-client'].focus()"
                    @contextmenu="rightClickHandler"
                    class="ml-auto"
                >
                    <vet-select-client
                        ref="select-client"
                        :key="'search' + searchClientKey"
                        :focus-onload="isClientDashboard"
                        class="mr-sm-2 w-100 search nav-search show-actions"
                    />
                </b-nav-form>
            </b-navbar-nav>
        </b-navbar>
        <details-confirm-exemption
            modal-id="confirm-remove-late-fees"
            @confirm="confirmRemoveLateFees"
        />
        <details-confirm-deactivate
            modal-id="confirm-deactivate"
            @confirm="confirmDeactivate"
        />
        <router-view
            ref="routerView"
            :profileMode="profile.mode"
            @edit-saved="editSaved"
            @letter-status="setLetterStatus"
            @redirectToClientProfile="redirectToClientProfile"
            @update-photo="updatePhoto"
        ></router-view>
        <modal-upload-photo ref="modalUploadPhoto" />
        <modal-remove-photo ref="modalRemovePhoto" />
        <modal-delete ref="modalDelete" @success="redirectToClientList()" />
        <modal-merge ref="modalMerge" @onSuccess="onSuccessMergeClient" />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import vetSelectClient from "@/module/commons/vet-select-client";
import modalUploadPhoto from "@/components/client-photos/photo-upload-modal";
import modalRemovePhoto from "@/components/client-photos/photo-remove-modal";
import ModalDelete from "@/components/client/modal-delete";
import NavbarWebform from "@/components/webform/navbar";
import ModalMerge from "@/components/client/modal-merge";
import SettingMixins from "@/mixins/settings";
import ClientMixins from "@/mixins/client";
import EXTENSIONS from "@/constants/extensions";
import EVENT from "@/constants/events";

export default {
    components: {
        vetSelectClient,
        modalUploadPhoto,
        modalRemovePhoto,
        DetailsConfirmDeactivate: () =>
            import("@/components/client-details/details-confirm-deactivate"),
        DetailsConfirmExemption: () =>
            import("@/components/client-details/details-confirm-exemption"),
        ModalDelete,
        ModalMerge,
        NavbarWebform
    },
    beforeMount() {
        this._getSetting().then(() => {
            if (!this._hasAccess("client.access")) {
                this._redirectDefaultPage();
                this.$destroy();
            }
        });
    },
    mixins: [SettingMixins, ClientMixins],
    data() {
        return {
            isSavingNewClient: false,
            isSavingClient: false,
            searchClientKey: 0,
            profile: {
                currentView: "",
                mode: "VIEW",
                isLock: false,
                isSaving: false,
                isLetterEdit: false
            },
            letter: {
                hasSignature: false,
                hasSigned: false
            }
        };
    },
    computed: {
        isClientNew() {
            return this.$route.name == "client_new";
        },
        isClientProfile() {
            return this.$route.name == "client_profile" || this.$route.name == "direct-url-client-profile";
        },
        isClientDashboard() {
            return this.$route.name == "client_dashboard";
        },
        isLetter() {
            return this.$route.name == "client_letter";
        },
        isWebform() {
            return this.$route.name == "client_webform";
        },
        ...mapGetters({
            isEditMode: "client/editMode",
            currentClient: "client/clientDetails",
            currentClientEdit: "client/editDetails"
        }),
        isClientNoOwner() {
            let details = this.$store.getters["client/clientDetails"];
            return details ? details.index == 1 : true;
        },
        permissions() {
            return this.$root.permissions;
        },
        isClientHasEmail() {
            return Boolean(this.currentClient?.email);
        }
    },
    watch: {
        client(data) {
            if (data && data.id) {
                this.$router.push({
                    name: "client_profile",
                    params: { id: data.encoded_id }
                });
            }
        },
        "$route.name"() {
            this.searchClientKey++;
        }
    },
    methods: {
        goToEdit() {
            this.reloadSettings().then(() => {
                this.$store.commit("client/setEditMode", true);
            });
        },
        goToNew() {
            this.reloadSettings().then(() => {
                this.$router.push("/client/new");
            });
        },
        cancelEdit() {
            this.$store.commit("client/setEditMode", false);
            this.$store.commit(
                "client/setEditDetails",
                _.cloneDeep(this.currentClient)
            );
        },
        cancelNew() {
            this.$store.commit("client/clearNewDetails");
            this.redirectToClientList();
        },
        redirectToClientProfile(clientEncodedId = null) {
            if (
                !clientEncodedId &&
                this.currentClient &&
                this.currentClient.encoded_id
            ) {
                clientEncodedId = this.currentClient.encoded_id;
            }

            if (clientEncodedId) {
                this.$router.replace({
                    name: "client_profile",
                    params: {
                        id: clientEncodedId
                    }
                });
            } else {
                this.redirectToClientList();
            }
        },
        triggerSave() {
            if (!this.currentClientEdit.canSave) {
                return false;
            }

            this.checkExemption();
        },
        confirmRemoveLateFees() {
            this.checkStatus();
        },
        confirmDeactivate(fields) {
            this.saveEditChanges(fields);
        },
        checkExemption() {
            if (
                _.findIndex(this.currentClient.exemptOptions, ["id", 1]) > -1 &&
                _.findIndex(this.currentClientEdit.selectedExemptions, [
                    "id",
                    1
                ]) == -1
            ) {
                this.$bvModal.show("confirm-remove-late-fees");
            } else {
                this.checkStatus();
            }
        },
        checkStatus() {
            if (
                this.currentClientEdit.selectedStatus == 2 &&
                this.currentClient.status.id == 1
            ) {
                this.$bvModal.show("confirm-deactivate");
            } else {
                this.saveEditChanges(null);
            }
        },
        updatePhoto(action) {
            switch (action) {
                case "upload":
                    this.uploadPhoto();
                    break;
                case "remove":
                    this.removePhoto();
                    break;
            }
        },
        removePhoto() {
            let module = "CLIENT";
            this.$refs.modalRemovePhoto.open(module);
        },
        uploadPhoto() {
            let module = "CLIENT";
            this.$refs.modalUploadPhoto.open(module);
        },
        saveEditChanges(fields) {
            this.isSavingClient = true;

            let details = {
                smsEnabled:
                    this._isExtensionEnabled("SMS") ||
                    this._isExtensionEnabled("2_WAY_MESSAGING"),
                balanceAction: fields ? fields.balanceAction : "",
                refundType: fields ? fields.refundType : ""
            };
            this.$store
                .dispatch("client/updateClientDetails", details)
                .then(response => {
                    if (_.has(response, "id")) {
                        let query = this.$route.query;

                        if (query.isEditMode == "true") {
                            delete query.isEditMode;

                            this.$router.replace({
                                query: query
                            });
                        }

                        this.$store.dispatch("client/getClientDetails", {
                            id: this.currentClient.encoded_id,
                            encoded: true
                        });

                        this.showSuccessMessage(response.status_change);
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .then(() => {
                    this.isSavingClient = false;
                    this.$store.commit("client/setEditMode", false);
                    this.$tabEvent.emit(EVENT.REFRESH_PATIENT_PROFILE);
                })
                .catch(error => {
                    this._message(
                        "Error : Unable update profile record",
                        "danger"
                    );
                    console.error(error);
                });
        },
        showSuccessMessage(statusChange) {
            var message = "Profile record saved.";
            var status = Number(statusChange);

            switch (status) {
                case 1:
                    message = "Client successfully deactivated.";
                    break;
                case 2:
                    message =
                        "Client successfully deactivated and balance kept.";
                    break;
                case 3:
                    message =
                        "Client successfully deactivated and credit balance kept.";
                    break;
                case 4:
                    message =
                        "Client successfully deactivated and balance written off.";
                    break;
                case 5:
                    message =
                        "Client successfully deactivated and credit balance converted.";
            }

            this._message(message);
        },
        deleteClient() {
            this.$refs.modalDelete.open(this.currentClient);
        },
        redirectToClientList() {
            this.$router.replace("/client/dashboard");
        },
        mergeClient() {
            const { id, firstname, lastname } = this.currentClient;

            this.$refs.modalMerge.open({
                clientId: id,
                clientName: `${firstname} ${lastname}`
            });
        },
        async saveNewClient(repeat = false) {
            try {
                this.isSavingNewClient = true;
                let isMobileAppExtensionEnabled = this._isExtensionEnabled(
                    EXTENSIONS.CODE.CODE_CLIENT_MOBILE_APP
                );

                const res = await this.$store.dispatch("client/saveNewClient", {
                    isMobileAppExtensionEnabled
                });

                this.isSavingNewClient = false;

                if (res.data.state === 1) {
                    throw new Error("Error saving data");
                }

                const newClientEncodedId = res.data.id;
                this._message("Record successfully saved");
                this.$store.commit("client/clearNewDetails");

                // repeat = add new after save
                if (!repeat) {
                    this.$router.replace(
                        `/client/profile/${newClientEncodedId}`
                    );
                }
            } catch (e) {
                if (e.message === "CLIENT_MOBILE_APP_REQUIRES_EMAIL_PHONE") {
                    this.showMobileAppRequirementError();
                } else {
                    this._message(e.message, "danger");
                }

                this.isSavingNewClient = false;
            }
        },
        onSuccessMergeClient(targetClientEncodedId) {
            this.$router.replace(`/client/profile/${targetClientEncodedId}`);
        },
        async reloadSettings() {
            return this.getBusinessSettings();
        },
        rightClickHandler(e) {
            if (e.which === 3) {
                this.$refs["select-client"].focus();
            }
        },
        saveEditLetter() {
            this.profile.isSaving = true;
            this.$refs.routerView.saveEditLetter();
        },
        emailLetter() {
            this.$refs.routerView.emailLetter();
        },
        printLetter() {
            this.$refs.routerView.printLetter();
        },
        deleteLetter() {
            this.$refs.routerView.promptDelete("letter");
        },
        lockLetter() {
            this.$refs.routerView.promptLock();
        },
        signLetter() {
            this.$refs.routerView.promptSign();
        },
        clearSigniture() {
            this.$refs.routerView.clearSigniture();
        },
        editSaved(result = {}) {
            this.profile.isSaving = false;

            if (result.success) {
                this.profile.mode = "VIEW";
            }
        },
        setLetterStatus(result = {}) {
            if (result.isLock) {
                this.profile.isLock = true;
            } else {
                this.profile.isLock = false;
            }
            if (typeof result.isContentEdit == "boolean") {
                this.profile.isLetterEdit = result.isContentEdit;
            }
            if (typeof result.hasSignature == "boolean") {
                this.letter.hasSignature = result.hasSignature;
                if (typeof result.hasSigned == "boolean") {
                    this.letter.hasSigned = result.hasSigned;
                }
            }
        },
        changeEditMode(isEdit) {
            if (isEdit) {
                this.profile.mode = "EDIT";
            } else {
                this.profile.mode = "VIEW";
            }
        },
        changeIsSaving(isSaving) {
            this.profile.isSaving = isSaving;
        },
        deleteWebform(webform) {
            this.$refs.routerView.deleteWebform(webform);
        },
        sendEmail(webform) {
            this.$refs.routerView.sendEmail(webform);
        },
        sendSMS(webform) {
            this.$refs.routerView.sendSMS(webform);
        }
    }
};
</script>
